import { render, staticRenderFns } from "./predefine.vue?vue&type=template&id=eb9eb962&"
import script from "./predefine.vue?vue&type=script&lang=js&"
export * from "./predefine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb9eb962')) {
      api.createRecord('eb9eb962', component.options)
    } else {
      api.reload('eb9eb962', component.options)
    }
    module.hot.accept("./predefine.vue?vue&type=template&id=eb9eb962&", function () {
      api.rerender('eb9eb962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/common/color-picker/src/components/predefine.vue"
export default component.exports